import React, { useId, useState } from "react";
import PropTypes from "prop-types";
import "./CollapsePanel.scss";

const CollapsePanel = ({
  title,
  children,
  defaultOpen = false,
  className = "",
  bodyClassName = "",
  onToggle,
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const contentId = useId();

  const handleToggle = () => {
    setIsOpen((prevState) => {
      const nextState = !prevState;
      if (onToggle) {
        onToggle(nextState);
      }
      return nextState;
    });
  };

  return (
    <div className={`collapse-panel se-grey-background ${className}`.trim()}>
      <button
        type="button"
        className="collapse-panel__header"
        onClick={handleToggle}
        aria-expanded={isOpen}
        aria-controls={contentId}
      >
        <span className="collapse-panel__title">{title}</span>
        <span className="collapse-panel__icon" data-testid="collapse-icon" aria-hidden="true">
          <se-icon size="nano">{isOpen ? "arrow3_up" : "arrow3_down"}</se-icon>
        </span>
      </button>

      <div
        id={contentId}
        className={`collapse-panel__body ${bodyClassName}`.trim()}
        data-testid="collapse-body"
        hidden={!isOpen}
      >
        {children}
      </div>
    </div>
  );
};

CollapsePanel.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node,
  defaultOpen: PropTypes.bool,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  onToggle: PropTypes.func,
};

export default CollapsePanel;